import React, { ReactElement } from 'react';
import { Button, BUTTON_SIZE, BUTTON_STYLE_TYPE, BUTTON_TYPE } from 'b2b-components/theme/components/Button';
import {
  FormFieldSearchableSelect,
  SEARCHABLE_SELECT_STYLE_TYPE,
} from 'b2b-apps/shop/common/components/Form/FormFieldSearchableSelect';
import { getErrorMessage } from 'b2b-apps/shop/common/utils/form/form';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { FIELD_NAME, FormValuesType } from '../';
import { Props } from './';

const Body = ({
  currentWishlist,
  errors,
  handleSubmit,
  isSubmitting,
  onChange,
  onModalClose,
  options,
  touched,
  onLoadOptions,
  itemCount,
}: Props): ReactElement => {
  const t = useTranslate();

  return (
    <form onSubmit={handleSubmit}>
      <h5>{itemCount > 1
        ? t('Add {count} items to wishlist', { count: itemCount })
        : t('Add item to wishlist')}
      </h5>

      <div className='Modal-Content'>
        <FormFieldSearchableSelect
          name={FIELD_NAME.selectedWishlist}
          onChange={onChange}
          innerComponentProps={{
            error: getErrorMessage<FormValuesType>(
              errors[FIELD_NAME.selectedWishlist],
              touched[FIELD_NAME.selectedWishlist],
            ),
            isCreatable: true,
            options,
            styleType: SEARCHABLE_SELECT_STYLE_TYPE.outlined,
            text: {
              creating: t('Creating'),
              label: t('Select existing list or create a new one'),
              noOptions: t('Enter phrase to create a new wishlist'),
              placeholder: t('Select...'),
              loading: t('Loading...'),
            },
            value: currentWishlist,
            onLoadOptions,
            isAsynchronous: true,
          }}
        />
      </div>

      <div className="Modal-ButtonsWrapper">
        <Button
          className="Modal-ButtonDiscard"
          size={BUTTON_SIZE.small}
          onClick={onModalClose}
          styleType={BUTTON_STYLE_TYPE.light}
        >
          {t('Discard')}
        </Button>

        <Button
          isDisabled={isSubmitting}
          size={BUTTON_SIZE.small}
          type={BUTTON_TYPE.submit}
        >
          {isSubmitting ? t('Submitting...') : t('Add item to wishlist')}
        </Button>
      </div>
    </form>
  );
};

export { Body };
